import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink, useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import Spinner from "../../common/Spinner";
import {
  addUser,
  GetUser,
  updateUser,
} from "../../../redux/actions/userActions";
import { USER_EDIT_RESET } from "../../../redux/constants/UserContants";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EditIcon from "@mui/icons-material/EditOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AddUser = ({ match }) => {
  const userId = match.params.id;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [enablePassword, setEnablePassword] = useState(false);
  const dispatch = useDispatch();
  const [formState, setFormState] = useState({
    values: {
      name: "",
      email: "",
      password: "",
      role: "Member",
      isActive: true,
    },
    errors: {},
  });
  const [pageType, setPageType] = useState("");
  const location = useLocation();
  const user = useSelector((state) => state.userEdit.user);
  const organization = useSelector(
    (state) => state?.organizationDetails?.organization
  );
  const organizationId = organization?.organization_id;
  const role = useSelector((state) => state.userLogin.userInfo.data.role);

  useEffect(() => {
    setFormState({
      values: {
        name: "",
        email: "",
        password: "",
        role: "Member",
        isActive: true,
      },
      errors: {},
    });
    if (location.pathname.includes("user/add")) {
      setPageType("Add");
      setEnablePassword(true);
    } else if (location.pathname.includes("user/edit")) {
      setPageType("Edit");
      setEnablePassword(false);
      if (!user?.name || user?.id !== Number(userId)) {
        if (role === "Super_Admin") {
          dispatch(GetUser({ id: userId, organizationId: "" }));
        } else {
          dispatch(GetUser({ id: userId, organizationId }));
        }
      } else {
        setFormState({ values: user, errors: {} });
      }
      //}
    }
  }, [location, user, userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      const regex = /^[a-zA-Z0-9\s]*$/;
      if (regex.test(value)) {
        setFormState((prevState) => ({
          values: {
            ...prevState.values,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: getValidationError(name, value),
          },
        }));
      }
    } else {
      setFormState((prevState) => ({
        values: {
          ...prevState.values,
          [name]: value,
        },
        errors: {
          ...prevState.errors,
          [name]: getValidationError(name, value),
        },
      }));
    }
  };

  const getValidationError = (name, value) => {
    switch (name) {
      case "email":
        return !validateEmail(value) ? "Invalid email address" : "";
      case "password":
        return !validatePassword(value)
          ? "Password must be more than 6 characters"
          : "";
      default:
        return "";
    }
  };

  const validatePassword = (password) => {
    return password.length >= 6;
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleRole = (e) => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        role: e.target.type === "checkbox" ? e.target.checked : e.target.value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, role, password, isActive } = formState.values;
    console.log("Form is valid");
    setSubmitted(true);

    if (pageType === "Add") {
      if (name && email && role && password) {
        if (!formState.errors.email && formState.values.email) {
          if (!formState.errors.password && formState.values.password) {
            if (password.length < 6 || password.length > 15) {
              toast.error("Password must be between 6 and 15 characters");
            } else {
              setLoading(true);
              dispatch(
                addUser({ reqData: formState.values, organizationId })
              ).then((response) => {
                setFormState({
                  values: {
                    name: "",
                    email: "",
                    password: "",
                    role: "Member",
                    isActive: false,
                  },
                  errors: {},
                });
                setSubmitted(false);
                setLoading(false);
                navigateToUserList();
              });
            }
          } else {
            toast.error(formState.errors.password);
          }
        } else {
          toast.error(formState.errors.email);
        }
      } else if (
        !formState.values.name &&
        !formState.values.email &&
        !formState.values.password
      ) {
        toast.error("Fill all Details");
      } else if (!formState.values.name) {
        toast.error("Enter Name");
      } else if (!formState.values.email) {
        toast.error("Enter Email");
      } else if (!formState.values.password) {
        toast.error("Enter Password");
      }
    } else if (pageType === "Edit") {
      if (name && email && role) {
        if (enablePassword === true) {
          if (!formState.errors.password && formState.values.password) {
            if (password.length < 6 || password.length > 15) {
              toast.error("Password must be between 6 and 15 characters");
            } else {
              setLoading(true);
              let obj = {
                id: Number(userId),
                name: name,
                role: role,
                isActive: isActive,
                password: password,
              };

              let orgId = "";
              if (role === "Super_Admin") {
                orgId = "";
              } else {
                orgId = organizationId;
              }

              dispatch(updateUser({ reqData: obj, orgId })).then((response) => {
                setFormState({
                  values: {
                    name: "",
                    email: "",
                    password: "",
                    role: "Member",
                    isActive: false,
                  },
                  errors: {},
                });
                setSubmitted(false);
                setLoading(false);
                navigateToUserList();
              });
            }
          } else {
            toast.error(formState.errors.password);
          }
        } else {
          setLoading(true);
          let obj = {
            id: Number(userId),
            name: name,
            role: role,
            isActive: isActive,
          };
          let orgId = "";
          if (role === "Super_Admin") {
            orgId = "";
          } else {
            orgId = organizationId;
          }

          dispatch(updateUser({ reqData: obj, orgId })).then((response) => {
            setFormState({
              values: {
                name: "",
                email: "",
                password: "",
                role: "Member",
                isActive: false,
              },
              errors: {},
            });
            setSubmitted(false);
            setLoading(false);
            navigateToUserList();
          });
        }
      } else {
        toast.error("Fill all details....");
      }
    }
  };

  const navigateToUserList = () => {
    dispatch({ type: USER_EDIT_RESET });
    history.push("/users");
  };

  const handleToggleChange = () => {
    setFormState({
      ...formState,
      values: {
        ...formState.values,
        isActive: !formState.values.isActive, // Toggle the isActive value
      },
    });
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <>
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
              <Container maxWidth="lg" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
                <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, border: "1px solid", borderColor: "divider" }}>
                  <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
                    <IconButton component={RouterLink} to="/users" size="small" aria-label="Back">
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h3" component="h1">
                      {pageType === "Add" ? "Add user" : "Edit user"}
                    </Typography>
                  </Stack>

                  <form onSubmit={handleSubmit} noValidate>
                    <Stack spacing={3}>
                      <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
                        <TextField
                          label="Name"
                          name="name"
                          required
                          fullWidth
                          value={formState.values.name || ""}
                          onChange={handleChange}
                          error={submitted && !formState.values.name}
                          helperText={submitted && !formState.values.name ? "Name is required" : " "}
                        />
                        <TextField
                          label="Email"
                          type="email"
                          name="email"
                          required
                          fullWidth
                          disabled={pageType !== "Add"}
                          value={formState.values.email || ""}
                          onChange={handleChange}
                          error={Boolean((submitted && !formState.values.email) || formState.errors.email)}
                          helperText={
                            (submitted && !formState.values.email && "Email is required") ||
                            formState.errors.email ||
                            " "
                          }
                        />
                      </Stack>

                      <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
                        <Box sx={{ flex: 1, minWidth: 0, position: "relative" }}>
                          <TextField
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            required={enablePassword}
                            fullWidth
                            disabled={!enablePassword}
                            autoComplete="new-password"
                            value={formState.values.password || ""}
                            onChange={handleChange}
                            error={Boolean(submitted && enablePassword && !formState.values.password)}
                            helperText={
                              submitted && enablePassword && !formState.values.password
                                ? "Password is required"
                                : " "
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={togglePasswordVisibility}
                                    edge="end"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    disabled={!enablePassword}
                                  >
                                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          {pageType === "Edit" && (
                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                              {enablePassword ? (
                                <Button
                                  size="small"
                                  variant="text"
                                  startIcon={<CloseIcon fontSize="small" />}
                                  onClick={() => {
                                    setEnablePassword(false);
                                    setFormState((prev) => ({
                                      ...prev,
                                      values: { ...prev.values, password: "" },
                                    }));
                                  }}
                                >
                                  Don't change password
                                </Button>
                              ) : (
                                <Button
                                  size="small"
                                  variant="text"
                                  startIcon={<EditIcon fontSize="small" />}
                                  onClick={() => setEnablePassword(true)}
                                >
                                  Change password
                                </Button>
                              )}
                            </Stack>
                          )}
                        </Box>

                        <FormControl fullWidth>
                          <InputLabel id="role-label">Role</InputLabel>
                          <Select
                            labelId="role-label"
                            label="Role"
                            name="role"
                            value={formState.values.role || "Member"}
                            onChange={handleRole}
                            required
                          >
                            <MenuItem value="Member">Member</MenuItem>
                            <MenuItem value="Client">Client</MenuItem>
                            <MenuItem value="Tester">Tester</MenuItem>
                          </Select>
                        </FormControl>
                      </Stack>

                      <FormControlLabel
                        control={
                          <Switch
                            checked={!!formState.values.isActive}
                            onChange={handleToggleChange}
                          />
                        }
                        label="Active — user can log in and access this organization"
                      />

                      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ pt: 1 }}>
                        <Button type="submit" variant="contained" size="large" sx={{ minWidth: 140 }}>
                          {pageType === "Add" ? "Add user" : "Save changes"}
                        </Button>
                        <Button
                          type="button"
                          variant="outlined"
                          size="large"
                          sx={{ minWidth: 140 }}
                          onClick={() => navigateToUserList()}
                        >
                          Cancel
                        </Button>
                      </Stack>
                    </Stack>
                  </form>
                </Paper>
              </Container>
            </Box>
            <Footer />
          </Box>
        </div>
      </div>
      {loading && <Spinner fullscreen label="Saving…" />}
    </>
  );
};

export default AddUser;
